import React from "react";
import { motion } from "framer-motion";

// Half-doughnut style circular gauge 0-100
export const ScoreGauge = ({ value = 0, size = 220, label = "" }) => {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  const stroke = 14;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (v / 100) * c;
  const color = v >= 66 ? "#D4A73A" : v >= 40 ? "#F59E0B" : "#EF4444";

  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.06)" strokeWidth={stroke} fill="none" />
        <motion.circle
          cx={size / 2} cy={size / 2} r={r}
          stroke={color} strokeWidth={stroke} fill="none" strokeLinecap="round"
          strokeDasharray={c}
          initial={{ strokeDashoffset: c }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.6, ease: "easeOut" }}
          style={{ filter: `drop-shadow(0 0 10px ${color}66)` }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <motion.span
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.4 }}
          className="font-heading font-black text-5xl text-white"
          style={{ color }}
        >
          {Math.round(v)}
        </motion.span>
        <span className="text-xs text-slate-400 mt-1">/ 100</span>
        {label && <span className="text-[11px] uppercase tracking-widest text-slate-500 mt-2">{label}</span>}
      </div>
    </div>
  );
};
